import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    background: "#ee3a23",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PdfDisplay(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(true);
  const [url, setUrl] = React.useState({
    url: `https://docs.google.com/viewerng/viewer?url=${props.src}&embedded=true`,
    state: 0,
  });
  React.useEffect(() => {
    setUrl({
      url: `https://docs.google.com/viewerng/viewer?url=${props.src}&embedded=true`,
      state: url.state + 1,
    });
    setShowLoader(true);
  }, [props.src, open]);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <a href="#" onClick={handleClickOpen}>
        Open
      </a>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              View Document
            </Typography>
          </Toolbar>
        </AppBar>
        {showLoader && "Loading..."}
        <iframe
          src={url.url}
          frameborder="0"
          // height="100%"
          onLoad={() => {
            setShowLoader(false);
          }}
          style={{ width: "100%", height: "100%" }}
          // width="100%"
        ></iframe>
      </Dialog>
    </div>
  );
}
